import ko from "knockout";
import { MaybeObservable, MaybeObservableAttributes } from "flow/interfaces/MaybeObservable";
import viewHtml from "./checkboxClick.html";
import { selectLabel } from "flow/koHelpers/selectParam";
import createEnabler from "flow/koHelpers/createEnablerDisabler";
import { interceptAttributesWithDefaults } from "flow/koHelpers/interceptAttributes";

export interface ICheckboxClickParams {
    attr?: MaybeObservableAttributes;
    bold?: boolean;
    checked: MaybeObservable<boolean>;
    checkedValue?: MaybeObservable<any>;
    enable?: MaybeObservable<boolean>;
    disable?: MaybeObservable<boolean>;
    meta?: MaybeObservable<string>;
    text?: MaybeObservable<string>;
    click: () => boolean;
}

ko.components.register("ko-checkbox-click", {
    viewModel: function (params: ICheckboxClickParams) {
        this.checked = params.checked;
        this.click =
            params.click ||
            function () {
                return true;
            };
        this.takeInnerHtml = false;

        if (params.meta || params.text) {
            this.text = selectLabel(params.meta, params.text);
        } else {
            this.takeInnerHtml = true;
        }

        this.enable = createEnabler(params.enable, params.disable);

        this.attributes = interceptAttributesWithDefaults({}, params.attr);
    },
    template: viewHtml,
    synchronous: true
});
